<template>
  <options-menu
      :title="containerTitle"
      :container-name="containerName"
      :options="options"
      :width="menuWidth"
      :linked-ribbon="headerRibbon"
      :show-checkbox="false"
      ref="menu"
  ></options-menu>
  <form-container
      :title="formContainerTitle"
      :form-rows="formRows"
      ref="formContainer"
  ></form-container>
  <options-menu
      :show-checkbox="false"
      :show-folder="false"

      ref="optionsMenu"
      :title="optionsMenuTitle"
      :container-name="optionsMenuContainerName"
      :options="optionsMenuOptions"
  ></options-menu>

</template>

<script setup>
import { reactive, onMounted, onBeforeMount, watch, ref, nextTick } from 'vue';
import OptionsMenu from './../OptionsMenu/OptionsMenu.vue';
import FormContainer from './../FormContainer/FormContainer.vue';

import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';
import * as graphLib from './../GraphLib/graphLib.js';



const props = defineProps({
  ClientID: String,
  viewportID: String,
  headerRibbon: Object,
  contextPE: String
});



const containerTitle = ref('Menu'), containerName = ref(`rootMenu${oxygenUtil.getGUID()}`),menu = ref(null), client = ref({});

const menuWidth = ref('250px');

let viewport = ref({}), options = ref([]), isAccount = ref(false);

onBeforeMount(async ()=>{

    client.value = window.devStore.clients.find(e => e.Client === props.ClientID);
    attributionRecord.value = await getAttributionRecord();
    isAccount.value = await checkForAccount();
    if(!client.value.childViewports) {
      client.value.childViewports = {
        showInbox,
        showAttachments,
        showContacts,
        showFiles,
        showTasks
      };
    }

    if(!window.clientsAPI) {
      window.clientsAPI = {};
    }
    if(!window.clientsAPI[client.value.Client]) {
      window.clientsAPI[client.value.Client] = {};
    }

    //console.log('leftMenu-onBeforeMount', 'adding childViewports');

  if(!window.clientsAPI[client.value.Client].childViewports) {
    window.clientsAPI[client.value.Client].childViewports = {
      showInbox,
      showAttachments,
      showContacts,
      showFiles,
      showTasks
    }
  }

    options.value = [].concat([
      {
        icon: `fal fa-inbox-in`,
        title: 'Inbox',
        id: 'inbox',
        callback: ()=>{
          showInbox();
        },
        path: '000-inbox'
      },
      {
        icon: `far fa-folder`,
        title: oxygenUtil.config.attachmentsTitle,
        id: 'attachments',
        callback: ()=> {
          showAttachments();
        },
        path: '001-attachments'
      },
      {
        icon: `far fa-address-book `,
        title: 'Contacts',
        id: 'contacts',
        callback: ()=>{
          showContacts();
        },
        path: '0020-contacts'
      },
      {
        icon: `fal fa-users-rectangle`,
        title: 'Related Stages',
        id: 'related_stages',
        callback: ()=> {
          showRelatedDesks();
        },
        path: '0021-related-desks'
      },
      {
        icon: `fal fa-cart-shopping-fast`,
        title: 'Marketplace',
        id: 'marketplace',
        callback: ()=> {
          showMarketplace();
        },
        path: '00210-marketplace'
      },
      {
        icon: `fal fa-list-check`,
        title: 'Offer',
        id: 'offer',
        callback:  (data, dataRow, index, menuTable)=>{
          viewport.value.MessageBox.setupOfferTask();
        },
        path: '0021-tasks/001-offer'
      },
      {
        icon: `fal fa-list-check`,
        title: 'Request',
        id: 'request',
        callback:  (data, dataRow, index, menuTable)=>{
          viewport.value.MessageBox.setupRequestTask();
        },
        path: '0021-tasks/002-request'
      },
      {
        icon: `fa fa-chart-line-up `,
        title: 'Tracker',
        id: 'tracker',
        callback: ()=>{
          showTrackerFilterMenu()

        },
        path: '0022-tracker'
      },
      /*{
        icon: `far fa-address-book `,
        title: 'Contacts',
        callback: ()=>{
          showNormalContacts();
        },
        path: '0021-contacts'
      },*/
    ], ( isAccount.value ) ? [
      {
        icon: `fal fa-user-circle`,
        title: 'Accounts View',
        id: 'account_info',
        callback: ()=>{
          showAccountInfo();
        },
        path: '0030-account-info'
      },
    ] : [], [
      {
        icon: `fal fa-cloud  `,
        title: 'Files',
        id: 'files',
        callback: ()=>{
          showFiles();
        },
        path: '0031-files'
      },
      {
        icon: `fal fa-plus  `,
        title: 'Create New',
        id: 'create_new',
        callback: ()=>{
          showTemplates();
        },
        path: '00310-create-new'
      },
      {
        icon: `fal fa-share-alt-square`,
        title: 'Share',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          menuTable.folderClick(dataRow, index);
        },
        path: '0032-share'
      },
      {
        icon: ``,
        title: 'Offer',
        callback:  (data, dataRow, index, menuTable)=>{
          viewport.value.MessageBox.selectMode("share_mode", "shareMode", 'offer');
        },
        path: '0032-share/001-offer'
      },
      {
        icon: ``,
        title: 'Share',
        callback:  (data, dataRow, index, menuTable)=>{
          viewport.value.MessageBox.selectMode("share_mode", "shareMode", 'share');
        },
        path: '0032-share/002-share'
      },
      {
        icon: ``,
        title: 'Request',
        callback:  (data, dataRow, index, menuTable)=>{
          viewport.value.MessageBox.selectMode("share_mode", "shareMode", 'request');
        },
        path: '0032-share/001-request'
      },
      {
        icon: `fal fa-phone-plus   `,
        title: 'Call',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          menuTable.folderClick(dataRow, index);
        },
        path: '004-call'
      },
      {
        icon: ``,
        title: 'Message',
        callback:  (data, dataRow, index, menuTable)=>{
          viewport.value.MessageBox.selectMode("invitemodalid", "meetingMode", 'send');


        },
        path: '004-call/001-message'
      },
      {
        icon: ``,
        title: 'Call',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          viewport.value.MessageBox.selectMode("invitemodalid", "meetingMode", 'invite');
        },
        path: '004-call/002-call'
      },
      {
        icon: ``,
        title: 'Page',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          viewport.value.MessageBox.selectMode("invitemodalid", "meetingMode", 'page');
        },
        path: '004-call/003-page'
      },
      {
        icon: ``,
        title: 'Join',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          viewport.value.MessageBox.selectMode("invitemodalid", "meetingMode", 'join');
        },
        path: '004-call/004-join'
      },
      {
        icon: ``,
        title: 'Meet',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          viewport.value.MessageBox.selectMode("invitemodalid", "meetingMode", 'meet');
        },
        path: '004-call/005-meet'
      },
      {
        icon: ``,
        title: 'Promise',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          viewport.value.MessageBox.selectMode("invitemodalid", "meetingMode", 'promise');
        },
        path: '004-call/006-promise'
      },
      {
        icon: ``,
        title: 'Barge',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          viewport.value.MessageBox.selectMode("invitemodalid", "meetingMode", 'barge');
        },
        path: '004-call/007-barge'
      },
      {
        icon: ``,
        title: 'Whisper',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          viewport.value.MessageBox.selectMode("invitemodalid", "meetingMode", 'whisper');
        },
        path: '004-call/008-whisper'
      },
      {
        icon: ``,
        title: 'Spy',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          viewport.value.MessageBox.selectMode("invitemodalid", "meetingMode", 'spy');
        },
        path: '004-call/009-spy'
      },
      {
        icon: ``,
        title: 'Show',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          viewport.value.MessageBox.selectMode("invitemodalid", "meetingMode", 'show');
        },
        path: '004-call/010-show'
      },
      {
        icon: ``,
        title: 'Watch',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          viewport.value.MessageBox.selectMode("invitemodalid", "meetingMode", 'watch');
        },
        path: '004-call/011-watch'
      },
      {
        icon: ``,
        title: 'Draw',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          viewport.value.MessageBox.selectMode("invitemodalid", "meetingMode", 'draw');
        },
        path: '004-call/012-draw'
      },
      {
        icon: `fal fa-eye`,
        title: 'Views',
        callback:  (data, dataRow, index, menuTable)=>{
          //this.setReplyIcon('replySelect');
          menuTable.folderClick(dataRow, index);
        },
        path: '005-views'
      },
      {
        icon: `far fa-folders `,
        title: 'Template View',
        callback:  (data, dataRow, index, menuTable)=>{
          setView('Template');
        },
        path: '005-views/000-template'
      },
      {
        icon: `fal fa-list-ul  `,
        title: 'Data View',
        callback:  (data, dataRow, index, menuTable)=>{
          setView('Data');
        },
        path: '005-views/001-data'
      },
      {
        icon: `far fa-calendar-alt  `,
        title: 'Calendar View',
        callback:  (data, dataRow, index, menuTable)=>{
          setView('Calendar');
        },
        path: '005-views/002-calendar'
      },
      {
        icon: `fal fa-map-marked-alt  `,
        title: 'Map View',
        callback:  (data, dataRow, index, menuTable)=>{
          setView('Map');
        },
        path: '005-views/003-map'
      },
      {
        icon: `fal fa-table  `,
        title: 'Table View',
        callback:  (data, dataRow, index, menuTable)=>{
          setView('Table');
        },
        path: '005-views/004-table'
      },

      {
        icon: `fal fa-chart-line  `,
        title: 'Charts',
        callback:  (data, dataRow, index, menuTable)=>{
          setView('Graph');
        },
        path: '005-views/005-graph'
      },
      {
        icon: `fal fa-diagram-project`,
        title: 'Network View',
        callback:  (data, dataRow, index, menuTable)=>{
          setView('Network');
        },
        path: '005-views/006-network'
      }
    ]);


});

/*
{
        icon: `fal fa-inbox-in`,
        title: 'Inbox',
        id: 'inbox',
        callback: ()=>{
          showInbox();
        },
        path: '000-inbox'
      }
 */


let attributionRecord = ref(null), deskId;
onMounted(async ()=>{
  viewport.value = window.devStore.viewPorts.find(e => (e.viewportID === props.viewportID) );
  setupEventListeners();
  let deskContext = oxygenUtil.tryParseJSON(client.value.DeskContext);
  deskId = deskContext.Node && deskContext.Node.ID;

});


function setupEventListeners() {
  window.addEventListener(`${props.viewportID}-view-change`, (e)=>{
      console.log('view-event-called', 'e:', e);
      if(e.detail.CurrentView === 'Network') {
        let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/BehaviourFlows/index.html?clientID="+props.ClientID};
        window.BotServices.openChildPanel({ClientID : props.ClientID, DisplayName : 'Network View', Termination : terminationUrl}, ()=>{});
      }
    });
}

async function getAttributionRecord() {
  return await oxygenUtil.getAttributionRecord(client.value.Attribution);
}

function isCredentialAccount() {
  return window.LivingScript_0070.context.credentialId  === client.value.ClientRight;
}

function isGatewayAccount() {
  return attributionRecord.value.GatewayPE === JSON.parse(client.value.ClientContext).GrantPE
}

async function checkForAccount() {
  let results = await oxygenUtil.runDBQuery(
      `select ID from OxygenDatabase.Attribution where HostAccountID = ?`,
      [client.value.ClientRight]
  );
  return !!results.length;
}

function setView(viewName) {
  window.devStore.setCurrentView(props.viewportID, viewName);
  viewport.value.CurrentView = viewName;
  let event = new CustomEvent(`${props.viewportID}-view-change`, {
    detail: {
      CurrentView: viewName
    }
  });
  window.dispatchEvent(event);


}

function showAccountInfo(callback) {
  /*
  return showWebComponentViewport(
      {
        viewportID : oxygenUtil.getGUID(),
        ClientID : props.ClientID,
        MeetingPath : '',
        ClientPath : `${props.ClientID}/AccountInfo`,
        TopLeftX : "0px",
        TopRightY : "0px",
        ZIndex : 1000,
        Width:"415px",
        Height:"fit-content",
        PanelTitle: 'Account Info',
        DisplayState: ''
      },
      'Account Info',
      '/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/account-info-wc/dist/js/app.js',
      'oxygen-account-info'

  );

   */
  window.BotServices.openChildPanel({ClientID: props.ClientID, DisplayName: 'Accounts View',
    Termination: {
      MediaType : 'WebComponent',
      URL:'/simplia/dist/builds/account-info-wc/app.js',
      Template: 'oxygen-account-info',
      dataset: {}
    } } , (error, data)=>{
    if(callback) {
      if(error) {
        return callback(error);
      }
      callback(null, data.ViewPortID);
    }
  });
}

async function showInbox(...args) {
  let callback = args.length && args[args.length - 1], dataset;
  if(args.length > 1) {
    dataset = args[0];
  }
  /*
  return showWebComponentViewport(
      {
    viewportID : oxygenUtil.getGUID(),
    ClientID : props.ClientID,
    MeetingPath : '',
    ClientPath : `${props.ClientID}/Inbox`,
    TopLeftX : "0px",
    TopRightY : "0px",
    ZIndex : 1000,
    Width:"415px",
    Height:"fit-content",
    PanelTitle: 'Inbox',
    DisplayState: ''
  },
      'Inbox',
      '/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/inbox-wc/dist/js/app.js',
    'oxygen-inbox'

  );

   */
  console.log('showInbox', 'calling openChildPanel - clientId:', props.ClientID);

  let inbox = window.devStore.rootMenu.find(e => ((e.ClientRowID === props.ClientID) && e.Path.endsWith('/Inbox')));
  //console.log('switch_panel-callback', 'inbox:', inbox);
  if(inbox) {
    window.document.getElementById(inbox.ViewPortID).style.display = '';
    window.oxygenUtil.putViewportOnTop(inbox.ViewPortID);
    await nextTick();
    window.oxygenUtil.putViewportOnTop(inbox.ViewPortID);
    if(callback) {
      callback(null,inbox.ViewPortID);
    }

    //window.oxygenUtil.putViewportOnTop(inbox.ViewPortID);
  }
  else {
    window.BotServices.openChildPanel({ClientID: props.ClientID, DisplayName: 'Inbox',
      Termination: {
        MediaType : 'WebComponent',
        URL: '/simplia/dist/builds/inbox-wc/app.js',
        Template: 'oxygen-inbox',
        dataset: dataset || {}
      } } , (error, data)=>{
      if(callback) {
        if(error) {
          return callback(error);
        }
        callback(null, data.ViewPortID);
      }
    });
  }

}

window.showInbox = showInbox;

function showNormalContacts(callback) {
  /*
  return showWebComponentViewport(
      {
        viewportID : oxygenUtil.getGUID(),
        ClientID : props.ClientID,
        MeetingPath : '',
        ClientPath : `${props.ClientID}/Contacts`,
        TopLeftX : "0px",
        TopRightY : "0px",
        ZIndex : 1000,
        Width:"415px",
        Height:"fit-content",
        PanelTitle: 'Contacts',
        DisplayState: ''
      },
      'Contacts',
      '/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/normal-contacts-wc/dist/js/app.js',
      'oxygen-normal-contacts'

  );

   */
  window.BotServices.openChildPanel({ClientID: props.ClientID, DisplayName: 'Contacts',
    Termination: {
      MediaType : 'WebComponent',
      URL: '/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/normal-contacts-wc/dist/js/app.js',
      Template: 'oxygen-normal-contacts',
      dataset: {}
    } } , (error, data)=>{
    if(callback) {
      if(error) {
        return callback(error);
      }
      callback(null, data.ViewPortID);
    }
  });
}



async function showTracker(threadFlag, subjectFlag) {
  console.log('showTracker', 'threadFlag:', threadFlag, ' - subjectFlag:', subjectFlag);
  let subjectComponent, templateComponent, templateComponentID, threadComponent;

  let title  = `Tracker ( `;
  if(threadFlag) {
    threadComponent = await oxygenUtil.getComponent(client.value.ClientLeft);
    title += `${threadComponent.DisplayName}`
  }
  if(subjectFlag) {
    subjectComponent = await oxygenUtil.getComponent(client.value.ClientRight);
    templateComponentID = subjectComponent.MetaType === 'Template' ? subjectComponent.Node : subjectComponent.Template;
    templateComponent = templateComponentID === subjectComponent.Node ? subjectComponent : await oxygenUtil.getComponent(templateComponentID);
    title += `${threadFlag ? ' / ' : ''}${subjectComponent.DisplayName}`;
  }
  title += " )"

  //console.log('Tracker-Callback', 'templateComponentID:', subjectComponent.MetaType === 'Template' ? subjectComponent.Node : subjectComponent.Template);
  let trackerViewport = oxygenUtil.getGUID(), ClientID = client.value.Client;
  return oxygenUtil.showWebComponentViewport(
      client.value.Client,
      props.viewportID,
      {
        viewportID: trackerViewport,
        ClientID,
        MeetingPath : '',
        ClientPath : `${ClientID}/${title}`,
        TopLeftX : "0px",
        TopRightY : "0px",
        ZIndex : 1000,
        Width: "415px",
        Height: "fit-content",
        PanelTitle: title,
        DisplayState: ''
      },
      title,
      '/simplia/dist/builds/oxygen-tracker-wc/app.js',
      'oxygen-tracker',
      {
        templateComponentID,
        subjectComponentID: subjectComponent ? subjectComponent.Node : '',
        threadComponentID: threadComponent ? threadComponent.Node: '',
      }
  );


}

function showAttachments(callback) {
  /*
  return showWebComponentViewport(
      {
        viewportID : oxygenUtil.getGUID(),
        ClientID : props.ClientID,
        MeetingPath : '',
        ClientPath : `${props.ClientID}/Attachments`,
        TopLeftX : "0px",
        TopRightY : "0px",
        ZIndex : 1000,
        Width:"415px",
        Height:"fit-content",
        PanelTitle: 'Attachments',
        DisplayState: ''
      },
      'Attachments',
      '/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/attachments-wc-old/dist/js/app.js',
      'oxygen-attachments'
  );

   */
  window.BotServices.openChildPanel({ClientID: props.ClientID, DisplayName: oxygenUtil.config.attachmentsTitle,
    Termination: {
      MediaType : 'WebComponent',
      URL: '/simplia/dist/builds/attachments-wc-old/app.js',
      Template: 'oxygen-attachments',
      dataset: {}
    } } , (error, data)=>{
    if(callback) {
      if(error) {
        return callback(error);
      }
      callback(null, data.ViewPortID);
    }
  });
}

function showTasks(callback) {
  window.BotServices.openChildPanel({ClientID: props.ClientID, DisplayName: 'Tasks',
    Termination: {
      MediaType : 'WebComponent',
      URL: '/simplia/dist/builds/tasks-wc/app.js',
      Template: 'oxygen-tasks',
      dataset: {}
    } } , (error, data)=>{
    if(callback) {
      if(error) {
        return callback(error);
      }
      callback(null, data.ViewPortID);
    }
  });
}

async function showMarketplace(callback) {
  /*
  window.BotServices.openChildPanel({ClientID: props.ClientID, DisplayName: 'Marketplace',
    "Termination": {
      "CssLink": "",
      "MediaType": "WebComponent",
      "Template": "oxygen-marketplace",
      "URL": "/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/marketplace-wc/dist/js/app.js"
    } }, (error, data)=>{
    if(callback) {
      if(error) {
        return callback(error);
      }
      callback(null, data.ViewPortID);
    }
  });
*/


  let marketplaceComponent = await oxygenUtil.getComponent('_FFFFFFFFFFFFFF00001731965965540235_');
  let OpenPE = oxygenUtil.createSimpleOES([client.value.ClientRightRole, client.value.ClientRight, 'Customer', '_FFFFFFFFFFFFFF00001731965965540235_']);
  await window.oxygenUtil.pullPE(
      {
        ByClientID : client.value.Client,
        InitialContext : {
          ByClientID : client.value.Client
        },
        OpenPE
      },
      {
        GrantPE: OpenPE,
        GrantLeftDN: client.value.ClientRightDN,
        GrantRightDN: marketplaceComponent.DisplayName
      }
  );

  //await oxygenUtil.addRecent(OpenPE, client.value.ClientRightDN, marketplaceComponent.DisplayName);
  callback(null, {});

}

function showRelatedDesks(callback) {
  window.BotServices.openChildPanel({ClientID: props.ClientID, DisplayName: 'Related Stages',
    Termination: {
      MediaType : 'WebComponent',
      URL: '/simplia/dist/builds/related-desks-wc/app.js',
      Template: 'oxygen-related-desks',
      dataset: {}
    } } , (error, data)=>{
    if(callback) {
      if(error) {
        return callback(error);
      }
      callback(null, data.ViewPortID);
    }
  });
}

function showTemplates(callback) {
  window.BotServices.openChildPanel({ClientID: props.ClientID, DisplayName: 'Templates',
    Termination: {
      MediaType : 'WebComponent',
      URL: '/simplia/dist/builds/templates-wc/app.js',
      Template: 'oxygen-templates',
      dataset: {}
    } } , (error, data)=>{
    if(callback) {
      if(error) {
        return callback(error);
      }
      callback(null, data.ViewPortID);
    }
  });
}

function showContacts(...args) {
  console.log('showContacts', 'args:', args);
  let callback = args[args.length - 1], contactsMode = `${client.value.contactsMode}_contacts`;
  if(args.length > 1) {
    contactsMode = args[0];
  }

  client.value.childViewports.contactsPanel = null;
  window.BotServices.openChildPanel({ClientID: props.ClientID, DisplayName: 'Contacts',
    Termination: {
      MediaType : 'WebComponent',
      URL: '/simplia/dist/builds/contacts-wc/app.js',
      //URL: '/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/contacts-wc/dist/js/app.js',
      Template: 'oxygen-contacts',
      dataset: {
        contactsMode
      }
    } } , (error, data)=>{
    console.log('openChildPanel-callback', 'error:', error, ' - data:', data);
    let intervalID = setInterval(()=>{
      let panel;
      if(panel = client.value.childViewports.contactsPanel) {
        clearInterval(intervalID);
        panel.ctx._.exposed.setContactsMode(contactsMode);
      }
    },200);

    if(callback) {
      if(error) {
        return callback(error);
      }

      callback(null, data.ViewPortID);
    }
  });
}

function setupFileUploadEvent(viewportID) {
  if(window.SimpliaEvent) {
    client.value.mainFileUploadEvent = window.SimpliaEvent.addEventListener('fileImported', async (e) => {
      console.log('fileImported-event', 'e:', e);
      if(e.detail.PanelID === viewportID) {

        let fileEx = /^.+\/(.+)$/;
        let results = fileEx.exec(e.detail.filePath);
        let guid = e && e.detail && e.detail.component && e.detail.component.Node;
        console.log('fileImported-event', 'results:', results);
        if (results) {
          /*
          let guid;
          console.log('setupFileUploadEvent', 'flag:', client.value.ignoreAttachmentCreation);
          if(!client.value.ignoreAttachmentCreation) {
            guid = oxygenUtil.getGUID();
            let component = await oxygenUtil.createComponent("2016-11-08T21:52:39.289240Z000-0000Z", {
              Data: {
                fileUrl: e.detail.filePath
              }
            }, {
              Node: guid,
              DNPrefix: results[1],
              toPE: e.detail.ContextPE
            });
          }


           */

          console.log('fileImported-event', 'fileUploadCallbacks:', client.value.fileUploadCallbacks);
          if(client.value.fileUploadCallbacks) {
            Object.entries(client.value.fileUploadCallbacks).forEach((en)=>{
              console.log('fileImported-event', 'uploadId:', en[0], 'detail:', e.detail);
              en[1]({detail: Object.assign({}, e.detail, guid ? {componentId: guid} : {})});
            });
          }
        }
      }
    });

  }
}

function showFiles() {
  let viewportID = oxygenUtil.getGUID();

  if(client.value.mainFileUploadEvent){
    window.SimpliaEvent.removeEventListener('fileImported', client.value.mainFileUploadEvent);
  }
  setupFileUploadEvent(viewportID);

  return showWebComponentViewport(
      {
        viewportID,
        ClientID : props.ClientID,
        MeetingPath : '',
        ClientPath : `${props.ClientID}/Files`,
        TopLeftX : "0px",
        TopRightY : "0px",
        ZIndex : 1000,
        Width:"415px",
        Height:"450px",
        PanelTitle: 'Files',
        DisplayState: ''
      },
      'Files',
      '/simplia/dist/builds/iframe-container-wc/app.js',
      'iframe-container',
      {
        frameurl: `/OxygenFileServices-0070/import.html?${(new URLSearchParams({
          ContextPE: isCredentialAccount() ?
              ( oxygenUtil.createSimpleOES(['admin', client.value.ClientRight, 'admin', client.value.ClientRight]) ):
              oxygenUtil.createSimpleOES(
              [client.value.ClientLeftRole, client.value.ClientLeft, client.value.ClientRightRole, client.value.ClientRight]
          ),
          ClientID: props.ClientID,
          PanelID: viewportID}))}`
      }
  );
}

function showWebComponentViewport(viewportData, extendedTitle, wcURL, wcName, wcProps) {
  wcProps = wcProps || {};

  let terminationID = oxygenUtil.getGUID();
  let rootMenuItem = addRootMenuItem(extendedTitle, viewportData.viewportID, terminationID);
  //console.log('showWebComponentViewport', 'rootMenuItem:', rootMenuItem);
  //window.devStore.addViewPort(viewportData);
  if(rootMenuItem) {
    window.BotServices.PullViewPort(viewportData, rootMenuItem);
    //console.log('showWebComponentViewport', 'doing PullViewPort');
    const terminationObj = {
      viewportID: viewportData.viewportID,
      terminationID,
      MediaType : 'WebComponent',
      URL: wcURL,
      Template: wcName,
      dataset: wcProps
    };
    window.BotServices.PullTermination(terminationObj, rootMenuItem);
    //console.log('showWebComponentViewport', 'doing PullTermination')
  }
  console.log('showWebComponentViewport', 'viewportId:', viewportData.viewportID);
  return viewportData.viewportID;



  //console.log('showInbox', 'inboxTermination:', inboxTermination);
  //window.devStore.addTerminationPoint(inboxTermination);
}


function showMenu(alignmentElement) {
  menu.value.showMenuAlignedToElement(alignmentElement);
}

function addRootMenuItem(extendedPath, viewportID, terminationID) {
  //console.log('props.ClientID:', props.ClientID, ' - props.viewportID:', props.viewportID);
  let parentRootMenuItem = window.devStore.rootMenu.find(e => (e.ClientRowID === props.ClientID && e.ViewPortID === props.viewportID));
  //console.log('parentRootMenuItem:', parentRootMenuItem);
  if(parentRootMenuItem) {
    let childRootMenuItem = Object.assign(
        {},
        parentRootMenuItem,
        { Path: `${parentRootMenuItem.Path}/${extendedPath}`, extendedTitle: extendedPath
        });
    window.devStore.addRootMenu(childRootMenuItem);
    return childRootMenuItem;
  }
}

let formContainerTitle = ref(''), formRows = ref([]), formContainer = ref(null);

async function showTrackerFilterMenu() {
  formContainerTitle.value = 'Tracker Filter';
  let threadControlId = `id${oxygenUtil.getUUID()}`, subjectControlId = `id${oxygenUtil.getUUID()}`;
  formRows.value = [
    {
      type: "checkboxGroup",
      name: "filterGroup",
      disabled: false,
      required: false,
      hidden: false,
      label: "Filter:",
      labelWidth: "160px",
      labelPosition: "left",
      options: {
        rows: [
          {
            id: threadControlId,
            name: "thread",
            type: "checkbox",
            text: "Thread"
          },
          {
            id: subjectControlId,
            name: "subject",
            type: "checkbox",
            text: "Subject",
            checked: true
          }
        ]
      }
    },
    {
      type: "button",
      css: "spaced-button",
      name: "track",
      text: "Track",
      size: "medium",
      view: "flat",
      color: "primary"
    }
  ];

  formContainer.value.showContainerAlignedToElementInViewport(
      document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
      'bottom',
      document.getElementById(props.viewportID).getBoundingClientRect()
  );

  await nextTick();


  formContainer.value.formInstance.getItem("track").events.on("click", async ()=>{
    let vals = formContainer.value.formInstance.getItem("filterGroup").getValue();

    showTracker(vals[threadControlId], vals[subjectControlId]);
    formContainer.value.hide();


  });

}

let deskModeIcons = [
  {

    id: "navigate_left_end",
    iconInfo: { type: "css", classes: "fa-light fa-arrow-left-to-line", color: '#0072c5'},
    callback: deskNavigationHistoryLeftEndClicked,
    orientation: 'left',
    toolTip: "History Beginning",
    position: 1
  },
  {

    id: "navigate_left",
    iconInfo: { type: "css", classes: "fa-light fa-arrow-left", color: '#0072c5'},
    callback: deskNavigationHistoryLeftClicked,
    orientation: 'left',
    toolTip: "History Back",
    position: 1
  },
  {

    id: "navigate_right",
    iconInfo: { type: "css", classes: "fa-light fa-arrow-right", color: '#0072c5'},
    callback: deskNavigationHistoryRightClicked,
    orientation: 'left',
    toolTip: "History Next",
    position: 1
  },
  {

    id: "navigate_right_end",
    iconInfo: { type: "css", classes: "fa-light fa-arrow-right-to-line", color: '#0072c5'},
    callback: deskNavigationHistoryRightEndClicked,
    orientation: 'left',
    toolTip: "History End",
    position: 1
  },
  {

    id: "angle_left",
    iconInfo: { type: "css", classes: "fa-light fa-angle-left", color: '#0072c5'},
    callback: deskNavigationLeftClicked,
    orientation: 'left',
    toolTip: "Left",
    position: 1
  },
  {

    id: "angle_up",
    iconInfo: { type: "css", classes: "fa-light fa-angle-up", color: '#0072c5'},
    callback: deskNavigationUpClicked,
    orientation: 'left',
    toolTip: "Up",
    position: 1
  },
  {

    id: "angle_down",
    iconInfo: { type: "css", classes: "fa-light fa-angle-down", color: '#0072c5'},
    callback: deskNavigationDownClicked,
    orientation: 'left',
    toolTip: "Down",
    position: 1
  },
  {

    id: "angle_right",
    iconInfo: { type: "css", classes: "fa-light fa-angle-right", color: '#0072c5'},
    callback: deskNavigationRightClicked,
    orientation: 'left',
    toolTip: "Right",
    position: 1
  }
];

function openExistingDesk(deskInfo) {
  let client, viewportId;
  if((client = window.devStore.clients.find((e)=>{
    let deskContext;
    if(deskContext = oxygenUtil.tryParseJSON(e.DeskContext)) {
      return deskContext.Node && deskContext.Node.ID && (deskContext.Node.ID === deskInfo.deskId);
    }
    return false;
  })) && (viewportId = oxygenUtil.getMainViewportIDFromClient(client.Client))) {
    window.oxygenUtil.putViewportOnTop(viewportId);
  }
  else {
    window.oxygenUtil.pullPE(deskInfo.pullPEParams);
  }

}

async function deskNavigationHistoryLeftClicked() {
  if(window.oxygenUtil.currentNavigationIndex > 0) {
    window.oxygenUtil.setCurrentNavigationIndex(window.oxygenUtil.currentNavigationIndex - 1);
    openExistingDesk(window.oxygenUtil.deskNavigationList[window.oxygenUtil.currentNavigationIndex]);
  }
}

async function deskNavigationHistoryRightClicked() {
  if(window.oxygenUtil.currentNavigationIndex < (window.oxygenUtil.deskNavigationList.length - 1)) {
    window.oxygenUtil.setCurrentNavigationIndex(window.oxygenUtil.currentNavigationIndex + 1);
    openExistingDesk(window.oxygenUtil.deskNavigationList[window.oxygenUtil.currentNavigationIndex]);
  }
}

async function deskNavigationHistoryLeftEndClicked() {
  if(window.oxygenUtil.currentNavigationIndex > 0) {
    window.oxygenUtil.setCurrentNavigationIndex(0);
    openExistingDesk(window.oxygenUtil.deskNavigationList[window.oxygenUtil.currentNavigationIndex]);
  }
}

async function deskNavigationHistoryRightEndClicked() {
  if(window.oxygenUtil.currentNavigationIndex < (window.oxygenUtil.deskNavigationList.length - 1)) {
    window.oxygenUtil.setCurrentNavigationIndex(window.oxygenUtil.currentNavigationIndex.length - 1);
    openExistingDesk(window.oxygenUtil.deskNavigationList[window.oxygenUtil.currentNavigationIndex]);
  }
}

/*

async function deskNavigationHistoryLeftClicked() {
  let originObj, navTree;
  if((originObj = window.deskNavigationList[getCurrentOriginDeskID()]) &&
      (navTree = originObj.navTree).length &&
      (originObj.currentIndex)) {
    window.BotServices.ShowClient(navTree[--originObj.currentIndex].clientID);
  }
}

async function deskNavigationHistoryRightClicked() {
  let originObj, navTree;
  if((originObj = window.deskNavigationList[getCurrentOriginDeskID()]) &&
      (navTree = originObj.navTree).length &&
      ((originObj.currentIndex + 1) < navTree.length)) {
    window.BotServices.ShowClient(navTree[++originObj.currentIndex].clientID);
  }
}

async function deskNavigationHistoryLeftEndClicked() {
  let originObj, navTree;
  if((originObj = window.deskNavigationList[getCurrentOriginDeskID()]) &&
      (navTree = originObj.navTree).length &&
      (originObj.currentIndex)) {

    window.BotServices.ShowClient(navTree[originObj.currentIndex = 0].clientID);
  }
}

async function deskNavigationHistoryRightEndClicked() {
  let originObj, navTree;
  if((originObj = window.deskNavigationList[getCurrentOriginDeskID()]) &&
      (navTree = originObj.navTree).length &&
      ((originObj.currentIndex + 1) < navTree.length)) {
    window.BotServices.ShowClient(navTree[originObj.currentIndex = (navTree.length - 1)].clientID);
  }
}
*/

async function deskNavigationUpClicked() {
  if(client.value.DeskContext) {

    let graphInfo = await getGraphInfo();
    window.devStore.clients.find(e => e.Client === client.value.Client).graphInfo = graphInfo;

    let incomingEdges = filterGraphForEdges(graphInfo, { 'RightID': deskId});
    let incomingNodes = convertEdgesToNodes(graphInfo, incomingEdges, 'LeftID');

    showNodesList('Up', incomingNodes, 'up');
  }
}



async function deskNavigationLeftClicked() {
  let initialContext = oxygenUtil.tryParseJSON(client.value.InitialContext), parentGraph;
  if(initialContext && (parentGraph = await getParentGraph(initialContext))) {
    console.log('deskNavigationLeftClicked', 'parentGraph:', parentGraph);
    let outgoingEdges = filterGraphForEdges(parentGraph, { 'LeftID': initialContext.ParentDeskID});
    let outgoingNodes = convertEdgesToNodes(parentGraph, outgoingEdges, 'RightID');
    console.log('deskNavigationLeftClicked', 'outgoingNodes:', outgoingNodes);
    console.log('deskNavigationLeftClicked', 'deskId:', deskId);
    let currentDeskIndex = outgoingNodes.findIndex(e => e._source.ID === deskId);
    console.log('deskNavigationLeftClicked', 'currentDeskIndex:', currentDeskIndex);
    if(currentDeskIndex > 0) {
      //Open the node

      openDesk(outgoingNodes[currentDeskIndex - 1]._source.ContextPE, outgoingNodes[currentDeskIndex - 1]._source.ID, 'left', initialContext.ParentDeskID);

    }
  }
}

async function getParentGraph(initialContext) {
  let client, graphInfo;

  return( (client = window.devStore.clients.find(e => e.Client === initialContext.ParentClientID)) && client.graphInfo) ||
      (await getGraphInfo(initialContext.ByClientSubject, initialContext.ByContextPE));
}

async function deskNavigationRightClicked() {
  let initialContext = oxygenUtil.tryParseJSON(client.value.InitialContext), parentGraph;
  if(initialContext && (parentGraph = await getParentGraph(initialContext))) {
    let outgoingEdges = filterGraphForEdges(parentGraph, { 'LeftID': initialContext.ParentDeskID});
    let outgoingNodes = convertEdgesToNodes(parentGraph, outgoingEdges, 'RightID');

    let currentDeskIndex = outgoingNodes.findIndex(e => e._source.ID === deskId);

    if((currentDeskIndex !== -1) && (currentDeskIndex + 1 < outgoingNodes.length)) {
      //Open the node

      openDesk(outgoingNodes[currentDeskIndex + 1]._source.ContextPE, outgoingNodes[currentDeskIndex + 1]._source.ID,
          'right', initialContext.ParentDeskID);
    }
  }

}

function openDesk(contextPE, DeskID, deskNavMode, ParentDeskID) {
  let originDeskClientID = getCurrentOriginDeskID();
  let pullPEParams = {
    ByClientID : client.value.Client,
    InitialContext : {
      ByClientID : client.value.Client,
      ByDeskID: deskId,
      ParentDeskID: ['down'].includes(deskNavMode) ? deskId : ( ['left','right'].includes(deskNavMode) ? ParentDeskID : null),
      ByClientSubject: client.value.ClientRight,
      ByContextPE: getContextPE(),
      OriginDeskClientID: originDeskClientID,
      DeskNavMode: deskNavMode
    },
    OpenPE : contextPE,
    DeskID
  };

  //window.oxygenUtil.addDeskNavigation(originDeskClientID, e._source.ID, client.value.Client, pullPEParams);
  if(window.oxygenUtil.currentNavigationIndex === -1) {
    addCurrentDeskToNavigationList();
  }
  window.oxygenUtil.addDeskNavigation(DeskID, pullPEParams);
  window.oxygenUtil.pullPE(pullPEParams);
}

function addCurrentDeskToNavigationList() {
  let InitialContext = oxygenUtil.tryParseJSON(client.value.InitialContext);
  window.oxygenUtil.addDeskNavigation(deskId, {
    ByClientID : InitialContext.ByClientID || '',
    InitialContext,
    OpenPE : getContextPE(),
    DeskID: deskId
  });
}

async function deskNavigationDownClicked() {
  if(client.value.DeskContext) {
    let graphInfo = await getGraphInfo();

    let outgoingEdges = filterGraphForEdges(graphInfo, { 'LeftID': deskId});
    console.log('deskNavigationDownClicked', 'outgoingEdges:', outgoingEdges);
    let outgoingNodes = convertEdgesToNodes(graphInfo, outgoingEdges, 'RightID');
    console.log('deskNavigationDownClicked', 'outgoingNodes:', outgoingNodes);

    showNodesList('Down', outgoingNodes, 'down');
  }
}

function convertEdgesToNodes(graphInfo, edges, edgeName) {
  console.log('convertEdgesToNodes', 'edges:', edges, ' - edgeName:', edgeName)
  let nodeList = Array.from( new Set(edges.map(e => e._source[edgeName])));
  return graphInfo.graph.filter((e)=> {
    return ( e._source.GraphMetaType && (e._source.GraphMetaType === 'Node') &&
        nodeList.includes(e._source.ID));
  });
}

function filterGraphForEdges(graphInfo, valMap) {
  return graphInfo.graph.filter((e) => {
    return ( e._source.GraphMetaType && (e._source.GraphMetaType === 'Edge') &&
        (graphInfo.roles.some(r => (r.role === e._source.ContextRightR))) &&
         Object.entries(valMap).every(en => e._source[en[0]] === en[1]));
  });
}

function getGraphNode(graphInfo, nodeId) {
  return graphInfo.graph.find((e)=>{
    return ( e._source.GraphMetaType && (e._source.GraphMetaType === 'Edge') &&
        (e._source.ID === nodeId) );
  });
}

function showNodesList(label, nodes, mode) {
  optionsMenuOptions.length = 0;
  optionsMenuTitle.value = label;
  nodes.forEach((e,i)=>{
    optionsMenuOptions.push({
      icon: '',
      title: e._source.DisplayName,
      callback: ()=>{
        openDesk(e._source.ContextPE, e._source.ID, mode);
        optionsMenu.value.hideMenu();
      },
      path: `${i.toString().padStart(3,'0')}-${e[0]}`
    });
  });


  optionsMenu.value.showMenuAlignedToElement(
      document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
      'bottom',
      document.getElementById(props.viewportID).getBoundingClientRect()
  );

}

function getContextPE() {
  return (window.LivingScript_0070.context.credentialId  === client.value.ClientRight) ?
      ( oxygenUtil.createSimpleOES(['admin', client.value.ClientRight, 'admin', client.value.ClientRight]) ):
      oxygenUtil.createSimpleOES([client.value.ClientLeftRole, client.value.ClientLeft, client.value.ClientRightRole, client.value.ClientRight]);
}


async function getGraphInfo(componentId, contextPE) {
  componentId = componentId || client.value.ClientRight;
  contextPE = contextPE || getContextPE();
  return await async.parallel({
    graph: async () => {
      return (await graphLib.getCompleteGraph(componentId)).graph;
    },
    roles: async () => {
      console.log('getGraphInfo', 'contextPE:', contextPE);
      let parsedContextPE = oxygenUtil.parseOES(contextPE).segments;
      let roles = await oxygenUtil.getAvailableComponentsRoles(
          [
            {
              id: parsedContextPE[3],
              defaultRole: parsedContextPE[2]
            }
          ],
          parsedContextPE[1],
          parsedContextPE[0],
          [],
          []
      );
      return roles[parsedContextPE[3]];
    }
  });

}

function getCurrentOriginDeskID() {
  let initialContext;
  return ( (initialContext = oxygenUtil.tryParseJSON(client.value.InitialContext)) && initialContext.OriginDeskClientID) ||
  client.value.Client;
}

const optionsMenuTitle = ref('Options'), optionsMenuContainerName = ref(`ud${oxygenUtil.getUUID()}`), optionsMenuOptions = reactive([]), optionsMenu = ref(null);



defineExpose({
  setView,
  showMenu,
  showFiles,
  showAttachments,
  showInbox,
  showTasks,
  showAccountInfo,
  options,
  deskModeIcons
});

</script>